export default "__VITE_ASSET__b8dfec6a__"